module.exports = __webpack_public_path__ + "static/media/Repair-Grandson.92790e0d.jpg";